import { htmlIdGenerator } from "@inscopix/ideas-eui";
import { GridApi } from "ag-grid-community";
import { addToast } from "components/GlobalToastList/GlobalToastList";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useCallback } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { DataTableRowData } from "../DataTable";

export const useExecuteAnalysisTableRows = (
  gridApi: GridApi<DataTableRowData> | undefined,
) => {
  const _executeAnalysisTableRows = useDataTableContext(
    (s) => s.executeAnalysisTableRows,
  );

  const executeAnalysisTableRows = useCallback(
    async (rowIds: string[], tableId: string) => {
      const { data, error } = await _executeAnalysisTableRows({
        tableId,
        rowIds,
      });

      if (error === undefined) {
        if (data.length === rowIds.length) {
          addUtilityToastSuccess("Row(s) running");
        } else {
          addToast({
            id: htmlIdGenerator()(),
            title: "One or more resource quotas exceeded",
            color: "warning",
            text: <p>Some rows were not run</p>,
          });
        }
        rowIds.forEach((id) => {
          gridApi?.getRowNode(id)?.setSelected(false);
        });
      } else {
        addUtilityToastFailure("Failed to run row(s)");
      }
    },
    [_executeAnalysisTableRows, gridApi],
  );

  return executeAnalysisTableRows;
};
